// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import VueLocalStorage from 'vue-localstorage'
import VueAxios from 'vue-axios'
import { sync } from 'vuex-router-sync'
import VueI18n from 'vue-i18n'
import VueCookie from 'vue-cookie'
import VueModal from 'vue-js-modal'
import VeeValidate from 'vee-validate'
import Popup from './components/Popup'
import Popup1 from './components/PopupCallBack'
import Loading from './components/module/Loading'
import Scrollbar from './components/Scrollbar'
import Info from './components/module/InfoTips'
import _ from 'lodash'
import './assets/scss/common.scss'
import Toast from './components/module/Toast'
import xss from 'xss'
import Eng from './locales/ENG'
Object.defineProperty(Vue.prototype, '$xss', {
  value: xss
})

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueLocalStorage)
Vue.use(VueI18n)
Vue.use(VueCookie)
Vue.use(VueModal, {
  dialog: true
})
Vue.use(VeeValidate, {
  events: 'change|blur'
})
// Vue.use(_)

Vue.component('popup-confirm', Popup)
Vue.component('popup-call-back', Popup1)
Vue.component('loading', Loading)
Vue.component('scrollbar', Scrollbar)
Vue.component('info-tips', Info)
Vue.component('toast', Toast)

Vue.prototype.$compareObj = function (obj1, obj2) {
  return _.isEqual(obj1, obj2)
}

Vue.prototype.$getElementsByClassName = function (node, classname) {
  if (node.getElementsByClassName) {
    return node.getElementsByClassName(classname)
  } else {
    var results = []
    let elems = node.getElementsByTagName('*')
    for (var i = 0; i < elems.length; i++) {
      if (typeof (elems[i].className) === 'object') {
        let classes = elems[i].className.baseVal.split(' ')
        if (classes.includes(classname)) {
          results[results.length] = elems[i]
        }
      } else {
        if (elems[i].className === classname) {
          results[results.length] = elems[i]
        }
      }
    }
    return results
  }
}
Vue.prototype.$isOverflow = function (id) {
  let el = document.getElementById(id)
  if (el) {
    if (el.offsetWidth < el.scrollWidth) return id
  }
}
if (!Array.prototype.forEach) {
  // eslint-disable-next-line
  Array.prototype.forEach = function(callback/*, thisArg*/) {
    var T, k
    if (this == null) {
      throw new TypeError('this is null or not defined')
    }
    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this)

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function')
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = arguments[1]
    }

    // 6. Let k be 0.
    k = 0

    // 7. Repeat while k < len.
    while (k < len) {
      var kValue

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator.
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c.
      // c. If kPresent is true, then
      if (k in O) {
        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k]

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O)
      }
      // d. Increase k by 1.
      k++
    }
    // 8. return undefined.
  }
}

sync(store, router)
let localStorage = {}

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8'
Vue.locale('ENG', Eng)
Vue.config.fallbackLang = 'ENG'
/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  localStorage,
  router,
  components: { App },
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js